import { createSelector } from '@ngrx/store'
import { AppState } from '../index'
import { UserRoles } from './../../../admin/model/admin.model'

export const selectAuthState = (state: AppState) => state.auth

export const selectCarriers = createSelector(selectAuthState, (state) => state.carriers)

export const selectStudies = createSelector(selectAuthState, (state) => state.studies)

export const selectSageLogicalRole = createSelector(
  selectAuthState,
  (state) => state.sageLogicalRole,
)

export const selectFeatureFlags = createSelector(selectAuthState, (state) => state.featureFlags)

export const selectRoles = createSelector(selectAuthState, (state) => state.roles)

export const selectAllowedRoles = createSelector(selectAuthState, (state) => state.allowedRoles)

export const selectIsAuthorized = createSelector(
  selectRoles,
  selectAllowedRoles,
  (roles, allowedRoles) => roles.some((role) => allowedRoles.includes(role)),
)

export const selectUserName = createSelector(selectAuthState, (state) => state.username)

export const selectCreditReinsurer = createSelector(
  selectAuthState,
  (state) => state?.creditReinsurer,
)

/**
 * if user is a client, they will only have one carrier, so return it
 */
export const selectAssignedClientId = createSelector(
  selectSageLogicalRole,
  selectCarriers,
  (sageLogicalRole, carriers) => {
    return sageLogicalRole === UserRoles.Client ? carriers.at(0)?.id : null
  },
)
